import { useApiToken } from '@/auth/hooks';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';
import { useEffect, useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ONBOARDING_ROUTE = '/app/onboarding';
const DASHBOARD_ROUTE = '/app/dashboard';
const WORKSPACES_ROUTE = '/app/workspaces';

export function WorkspaceGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { getAccessToken } = useApiToken();
  const { activeWorkspace, loadWorkspaces } = useWorkspaceStore();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    let active = true;

    async function hydrate() {
      const token = await getAccessToken().catch(() => null);
      await loadWorkspaces(token);
      if (active) {
        setHydrated(true);
      }
    }

    void hydrate().catch(() => setHydrated(true));

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onOnboarding = location.pathname.startsWith(ONBOARDING_ROUTE);
  const onDashboard = location.pathname.startsWith(DASHBOARD_ROUTE);
  const onWorkspaces = location.pathname.startsWith(WORKSPACES_ROUTE);

  if (!hydrated) {
    return <div className="p-6">Laden…</div>;
  }

  if (!activeWorkspace && !(onOnboarding || onDashboard || onWorkspaces)) {
    return <Navigate to={ONBOARDING_ROUTE} replace />;
  }

  return <>{children}</>;
}
